import gql from 'graphql-tag';
import { compose } from 'recompose';
import { get } from 'utils';
import { graphql } from 'graphql/utils';

export const withData = () =>
    compose(
        graphql(
            gql`
                query withEventGroup($eventGroupId: ID) {
                    eventGroups(filter: { eventGroupIds: [$eventGroupId] }) {
                        id
                        title
                    }
                }
            `,
            {
                props: ({ data }) => ({
                    label: get(data, 'eventGroups[0].title')
                }),
                skip: ({ eventGroupId }) => !eventGroupId,
                options: {
                    fetchPolicy: 'cache-first'
                }
            }
        )
    );
